import { Component, ChangeDetectionStrategy } from '@angular/core';

import { RouterModule } from '@angular/router';
import { DunaMapComponent } from '../duna-map/duna-map.component';

@Component({
  selector: 'app-duna-frontpage',
  imports: [RouterModule, DunaMapComponent],
  templateUrl: './duna-frontpage.component.html',
  styleUrl: './duna-frontpage.component.scss',
  // duna-full-bleed opts this component out of the global 14px side padding so the
  // hero section background reaches the screen edge. Internal spacing is handled via
  // the .container class (padding: 0 1.5rem) inside the component's own template.
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'duna-full-bleed' },
})
export class DunaFrontpageComponent {
  features = [
    {
      icon: 'event',
      title: 'Planlægning & tilmelding',
      description:
        'Kalender og oversigt over kurser, øvelser og uddannelser. Nem tilmelding for alle brandfolk.',
    },
    {
      icon: 'security',
      title: 'Sikkerhed i fokus',
      description:
        'Kryptering og løbende opdateringer sikrer tryg datahåndtering og beskyttelse af information.',
    },
    {
      icon: 'notifications',
      title: 'Notifikationer & fremmøde',
      description:
        'Automatiske påmindelser via push-beskeder og e-mails samt QR-scanning til registrering.',
    },
    {
      icon: 'group',
      title: 'Fællesskab & netværk',
      description:
        'Skab netværk og del erfaringer på tværs af stationer og organisationer i hele landet.',
    },
  ];

  stations = [
    {
      name: '4K',
      location: 'Beredskab 4K',
      featured: true,
    },
    {
      name: 'OSTBV',
      location: 'Østjyllands Brandvæsen',
      featured: true,
    },
    {
      name: 'BRSJ',
      location: 'Brand og Redning Sønderjylland',
      featured: true,
    },
  ];
}
